const apiUrl = process.env.REACT_APP_API_URL;
export const PostCasal = async ( json : any, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/casals`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        if (!response.ok) {
            console.log(await response.text());
        }
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
